import { AUTH_API, handleApiError } from '../../utils/axios';

export const getSpecifications = async () => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/specifications`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
